import { z } from 'zod';
import { getMutationSchema } from '../../../../ui/util/getMutationSchema';
import {
    ProcessArtifactDirection,
    ProcessArtifactDirectionSchema,
} from '../../../enumerations/ProcessArtifactDirection';
import { ResourceType } from '../../../enumerations/ResourceType';
import { useIndirectlyVersionedResourceAdapter } from '../../../resource-base/adapters/useIndirectlyVersionedResourceAdapter';
import { useMultiResourceSingleParentedResourceAdapterActions } from '../../../resource-base/adapters/useMultiResourceSingleParentedResourceAdapterActions';
import {
    defaultIndirectlyVersionedArtifactResource,
    IndirectlyVersionedArtifactResourceSchema,
} from '../../../resource-base/artifactResourceTypes';
import { IdSchema } from '../../../resource-base/baseSchemas';

export enum ProcessAreaProcessArtifactAssociationPropertyValidation {
    PROCESS_ARTIFACT = 'PROCESS_ARTIFACT',
    DIRECTION = 'DIRECTION',
}

export const ProcessAreaProcessArtifactAssociationResourceSchema = IndirectlyVersionedArtifactResourceSchema.extend({
    resourceType: z
        .literal(ResourceType.PROCESS_AREA_PROCESS_ARTIFACT_ASSOCIATION)
        .default(ResourceType.PROCESS_AREA_PROCESS_ARTIFACT_ASSOCIATION),
    processArtifact: IdSchema,
    direction: ProcessArtifactDirectionSchema,
});
export const ProcessAreaProcessArtifactAssociationMutationResourceSchema = getMutationSchema(
    ProcessAreaProcessArtifactAssociationResourceSchema
);

export type ProcessAreaProcessArtifactAssociationResource = z.infer<
    typeof ProcessAreaProcessArtifactAssociationResourceSchema
>;

export const defaultProcessAreaProcessArtifactAssociationResource: ProcessAreaProcessArtifactAssociationResource = {
    ...defaultIndirectlyVersionedArtifactResource,
    resourceType: ResourceType.PROCESS_AREA_PROCESS_ARTIFACT_ASSOCIATION,
    processArtifact: '',
    direction: ProcessArtifactDirection.INPUT,
};

export function useProcessAreaProcessArtifactAssociationActions() {
    return {
        ...useMultiResourceSingleParentedResourceAdapterActions(
            'project/process-area-process-artifact-association',
            ResourceType.PROCESS_AREA_PROCESS_ARTIFACT_ASSOCIATION,
            ProcessAreaProcessArtifactAssociationResourceSchema
        ),
        ...useIndirectlyVersionedResourceAdapter(
            'project/process-area-process-artifact-association',
            ResourceType.PROCESS_AREA_PROCESS_ARTIFACT_ASSOCIATION,
            ProcessAreaProcessArtifactAssociationResourceSchema
        ),
    };
}
